import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import ReadyStep from './WizardSteps/ReadyStep/ReadyStep';
import PredefineStep from './WizardSteps/PredefineStep/PredefineStep';
import UpdateRouterStep from './WizardSteps/UpdateRouterStep/UpdateRouterStep';
import DefineNetworkStep from './WizardSteps/DefineNetworkStep/DefineNetworkStep';
import ErrorStep from './WizardSteps/ErrorStep/ErrorStep';
import CompletedStep from './WizardSteps/CompletedStep/CompletedStep';
import { getWizardStep, initiate } from './routerActivationWizardBlockSlice';

const RouterActivationWizardComponent = (props) => {
    
    useEffect(() => {
        if (props.equipmentId){
            const data = {EquipmentId : props.equipmentId};
            props.initiate(data);
        }     
    },[]);

    useEffect(() => { 
        if (props.requestId && props.requestId!=''){
            const data = {RequestId : props.requestId, CurrentStep: props.currentStep};
            props.getWizardStep(data);
        }     
    });

    var activeStepView = '';
    switch(props.currentStep)
    {
        case 'ready':
            activeStepView = <ReadyStep/>;
            break;
        case 'predefine':
            activeStepView = <PredefineStep/>;
            break;
        case 'update':
            activeStepView = <UpdateRouterStep/>;
            break;
        case 'define':
            activeStepView = <DefineNetworkStep/>;
            break;
        case 'error':
            activeStepView = <ErrorStep/>;
            break;  
        case 'complete':
            activeStepView = <CompletedStep/>;
            break;    

    }     

    return(activeStepView);
};

const mapStateToProps = (state) => {
    return {
        currentStep: state.RouterActivationWizardBlock.currentStep,
        requestId: state.RouterActivationWizardBlock.wizardRequestId,
        equipmentId:"AB"
    }
}

const mapDispatchToProps = {
    getWizardStep,
    initiate
}

export default connect(mapStateToProps, mapDispatchToProps)(RouterActivationWizardComponent);